import * as React from 'react';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import {
  AutocompleteProps as MuiAutocompleteProps,
  AutocompleteRenderInputParams as RenderInputParams,
} from '@material-ui/lab/Autocomplete';
import { Popper, PopperProps } from '@material-ui/core';
import { autocompleteInputBase, autocompleteRoot } from './autocompleteStyles';
import TextField, { TextFieldProps } from 'ui/TextField/TextField';

export interface AutocompleteProps<T>
  extends Omit<MuiAutocompleteProps<T, undefined, undefined, undefined>, 'renderInput'> {
  autofocus?: boolean;
  label?: string;
  renderInput?(params: RenderInputParams): JSX.Element;
  TextFieldProps?: Optional<TextFieldProps>;
  onChange(changeEvent: React.ChangeEvent<{}>, value: T | null): void;
  defaultValue?: T;
}

function Autocomplete<T>({
  autofocus = false,
  label,
  TextFieldProps,
  classes,
  ...rest
}: AutocompleteProps<T>) {
  const NoPortalPopper = (props: PopperProps) => {
    const { children } = props;
    return (
      <Popper
        {...props}
        placement="bottom"
        disablePortal
        modifiers={{
          flip: { enabled: true },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
            escapeWithReference: true,
          },
        }}
      >
        {children}
      </Popper>
    );
  };

  return (
    <MuiAutocomplete<T>
      css={autocompleteRoot}
      classes={classes}
      filterOptions={(x) => x}
      autoComplete
      includeInputInList
      renderInput={(params) => (
        <TextField
          css={autocompleteInputBase}
          label={label}
          autoFocus={autofocus}
          {...params}
          {...TextFieldProps}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'fake-value',
          }}
        />
      )}
      popupIcon={null}
      PopperComponent={NoPortalPopper}
      {...rest}
    />
  );
}

export default Autocomplete;
